import { render, staticRenderFns } from "./NewCategoryCard.vue?vue&type=template&id=11bb4bfe&scoped=true&"
import script from "./NewCategoryCard.vue?vue&type=script&lang=js&"
export * from "./NewCategoryCard.vue?vue&type=script&lang=js&"
import style0 from "./NewCategoryCard.vue?vue&type=style&index=0&id=11bb4bfe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11bb4bfe",
  null
  
)

export default component.exports